import { createSlice } from "@reduxjs/toolkit";

interface RootState {
    fetchLoading :boolean
    loading:boolean

}

const initialState: RootState = {
    loading: false,
    fetchLoading:false
   

};

export const loadingSlice :any = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setloading: (state: any, { payload }) => {
      state.loading = payload;
    },
    setFetchLoading: (state: any, { payload }) => {
      state.fetchLoading = payload;
    }
    
  },
  
});

export const {setloading,setFetchLoading} = loadingSlice.actions;

export const getLoadingDetails = (state: any) => state.loadingReducer;



export default loadingSlice.reducer;
